import Header from "@/atomic/atoms/Header";
import { InputMask } from "@react-input/mask";
import { PropsView } from "../Models/pin";
import Loading from "@/atomic/atoms/Loading";
import Button from "@/atomic/atoms/Button";

export default function ForgotPasswordPinView({
  timer,
  handleSubmit,
  pin,
  onChange,
  isLoading,
  error,
  handleTryAgain,
  goBack,
  isDisabled,
}: PropsView) {
  return (
    <div className="h-full relative">
      <Header
        title="Validar acesso"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div className="h-12">
            <h2 className="mt-6 text-black text-xl">Validar PIN</h2>
            <h3 className="text-black text-sm mt-2">Digite o código PIN enviado para o seu celular cadastrado. O tempo de duração é de 15 minutos</h3>
            <div className="mt-6 flex flex-col justify-center items-center">
              <div>
                <InputMask 
                  value={pin ?? ""}
                  onChange={onChange}
                  className={`w-[calc(260px)] tracking-[calc(20px)] text-black bg-transparent text-center h-7 text-2xl ${error && "text-red-600"}`} 
                  type="text" 
                  inputMode="numeric"
                  name="pin" 
                  placeholder="_____" 
                  mask="_____"
                  replacement={{ _: /\d/ }}
                />
                {error && <div className="flex item-center w-[calc(260px)] justify-center">
                  <img 
                    src={"/icon-error.png"}
                    width={16}
                    height={16}
                    alt="erro"
                    className="mr-1"
                  />
                  <p className="text-red-600 text-center text-xs">Pin inválido. Tente novamente.</p>
                </div>}
              </div>
              <p className="text-black mt-6 text-left text-xs">
                Não recebeu o PIN por SMS? Tente estas opções:
                <br/>- Verifique se o número do Pedágio Eletrônico Sem Parar está bloqueado e, se necessário, desbloqueie.
                <br/>- Confirme se digitou o número correto.
                <br/>- Confira se há sinal da sua operadora.
                <br/>- Tente novamente.
              </p>
              <button type="button" className="text-black mt-6 text-base underline" onClick={handleTryAgain}>Reenviar código {timer !== 0 && "em 00:" + (timer < 10 ? "0" : "") + timer}</button>
            </div>
          </div>
          <Button 
            title="Avançar"
            type="submit"
            onClick={handleSubmit}
            isDisabled={isDisabled}
          />
        </article>
      </main>
      {isLoading && <Loading />}
    </div>
  );
}
